/* eslint-disable max-len */
/* eslint-disable security/detect-object-injection */
import React, { useCallback, useContext, useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate, useParams, useSearchParams } from 'react-router-dom';
import CardHeader from '../../../../../components/CardHeader';
import UpdateButton from '../../../../../components/UpdateButton';
import Toast from '../../../../../components/Toast';
import GlobalContext from '../../../../../components/Context/GloablContext';
import { dataService } from '../../../../../services/data.services';
import { GetBranchId } from '../../../../../CommonMethods/GetBranchId';
import { CognitoData } from '../../../../../CommonMethods/CognitoData';
import { useOnClickOutside } from '../../../../../CommonMethods/OutsideClick';
import S3UploadHook from '../../../../../CommonMethods/S3UploadHook';
import { downloadS3Object } from '../../../../../CommonMethods/S3DownloadHook';
import moment from 'moment';
import { ShimmerTitle } from 'react-shimmer-effects';
import FeeStructureDropdown from '../../../../../components/FeeStructureDropdown';
import TopBarWithShadow from '../../../../../components/TopBar/TopBarWithShadow';
import SearchShimmer from '../../../../../components/Shimmer/SearchShimmer';
import CustomOverLay from '../../../../../components/CustomOverlay';
import {
    getActiveSectionsByAssociations,
    filterAcademicYearsByAssociations,
    filterClassesByAssociations,
    getStaffAssociationsForAcademicYears,
    getStaffAssociationContext,
    isAdminCommunicationRole,
} from '../../associationUtils';
import { fetchNoticeTypeOptions, getNoticeTypeLabel, resolveNoticeTypeValue } from '../../noticeTypeUtils';
const ALLOWED_ATTACHMENT_TYPES = ['application/pdf', 'image/jpeg', 'image/jpg', 'image/png'];
const ALL_SECTIONS_OPTION = { _id: 'all', name: 'All Sections' };
const getCollectionFromResponse = (response) => (
    response?.data?.data?.data
    || response?.data?.data
    || []
);
const getAllowedAcademicYears = (academicYears = []) => (
    academicYears.filter((academicYear) => ['ongoing', 'upcoming'].includes(String(academicYear?.status || '').toLowerCase()))
);
const getActiveClasses = (classes = []) => classes.filter((classItem) => classItem?.status);

export default function AddUpdate({ edit }) {
    const { id } = useParams();
    const [searchParams] = useSearchParams();
    const location = useLocation();
    const forwardedContext = !edit ? (location.state?.classroomContext || null) : null;
    const isViewMode = searchParams.get('view') === 'true' || location.pathname.includes('/view/');
    const navigate = useNavigate();
    const { setToastmessage } = useContext(GlobalContext);
    const [toastErrorMessage, setToastErrorMessage] = useState('');
    const [loading, setLoading] = useState(false);
    const [pageLoading, setPageLoading] = useState(true);
    const [submitSelected, setSubmitSelected] = useState(false);

    // Context dropdowns
    const [academicYears, setAcademicYears] = useState(getAllowedAcademicYears(forwardedContext?.academicYears || []));
    const [classes, setClasses] = useState(getActiveClasses(forwardedContext?.classes || []));
    const [allClasses, setAllClasses] = useState(getActiveClasses(forwardedContext?.allClasses || []));
    const [sections, setSections] = useState([]);
    const [loadingClasses, setLoadingClasses] = useState(false);
    const [loadingSections, setLoadingSections] = useState(false);
    const [openDropdown, setOpenDropdown] = useState('');

    const [selectedAY, setSelectedAY] = useState(forwardedContext?.academicYear || {});
    const [selectedClass, setSelectedClass] = useState(forwardedContext?.classItem || {});
    const [selectedSection, setSelectedSection] = useState(forwardedContext?.section || {});

    // Notice fields
    const [noticeType, setNoticeType] = useState('');
    const [noticeTypes, setNoticeTypes] = useState([]);
    const [loadingNoticeTypes, setLoadingNoticeTypes] = useState(false);
    const [showAddNoticeType, setShowAddNoticeType] = useState(false);
    const [newNoticeTypeLabel, setNewNoticeTypeLabel] = useState('');
    const [receiverType, setReceiverType] = useState('class');
    const [title, setTitle] = useState('');
    const [description, setDescription] = useState('');
    const [attachments, setAttachments] = useState([]);
    const [uploading, setUploading] = useState(false);

    // Student search (for Specific Student receiver)
    const [studentSearch, setStudentSearch] = useState('');
    const [studentDropdown, setStudentDropdown] = useState([]);
    const [selectedStudent, setSelectedStudent] = useState({});
    const [studentSearchStarted, setStudentSearchStarted] = useState(false);
    const [loadingStudents, setLoadingStudents] = useState(false);
    const studentRef = useRef(null);
    useOnClickOutside(studentRef, () => {
        setStudentSearchStarted(false);
        setLoadingStudents(false);
    });

    // Edit mode context
    const [editContext, setEditContext] = useState({});
    const [userType, setUserType] = useState(forwardedContext?.userType || '');
    const [userEmail, setUserEmail] = useState(forwardedContext?.userEmail || '');
    const [isBatchedNotice, setIsBatchedNotice] = useState(false);
    const [staffAssociations, setStaffAssociations] = useState(forwardedContext?.staffAssociations || []);
    const [prefillApplied, setPrefillApplied] = useState(edit || Boolean(forwardedContext));

    const ayRef = useRef(null);
    const classRef = useRef(null);
    const sectionRef = useRef(null);
    const typeRef = useRef(null);
    const branchIdRef = useRef('');
    const associationsByAcademicYearRef = useRef(new Map());
    useOnClickOutside(ayRef, () => setOpenDropdown(d => d === 'ay' ? '' : d));
    useOnClickOutside(classRef, () => setOpenDropdown(d => d === 'class' ? '' : d));
    useOnClickOutside(sectionRef, () => setOpenDropdown(d => d === 'section' ? '' : d));
    useOnClickOutside(typeRef, () => {
        setOpenDropdown(d => d === 'type' ? '' : d);
        setShowAddNoticeType(false);
        setNewNoticeTypeLabel('');
    });

    const isAdminRole = isAdminCommunicationRole(userType);

    const getNoticeTypeValue = useCallback((typeIdOrKeyOrLabel) => (
        resolveNoticeTypeValue(typeIdOrKeyOrLabel, noticeTypes)
    ), [noticeTypes]);

    const getClassesForAcademicYear = useCallback((academicYearId) => {
        if (!academicYearId) return [];
        if (isAdminRole) return allClasses;
        return filterClassesByAssociations(allClasses, staffAssociations, academicYearId);
    }, [allClasses, isAdminRole, staffAssociations]);

    const getCachedBranchId = useCallback(async () => {
        if (branchIdRef.current) return branchIdRef.current;
        const branchId = await GetBranchId();
        branchIdRef.current = branchId;
        return branchId;
    }, []);

    const getCachedAssociationsForAcademicYear = useCallback(async (academicYearId) => {
        if (!academicYearId) return [];
        if (associationsByAcademicYearRef.current.has(academicYearId)) {
            return associationsByAcademicYearRef.current.get(academicYearId);
        }
        const branch_id = await getCachedBranchId();
        const assocRes = await dataService.GetAPI(`associations?branch_id=${branch_id}&academic_year_id=${academicYearId}&filter=true`);
        const assocData = assocRes.data?.data?.data || [];
        associationsByAcademicYearRef.current.set(academicYearId, assocData);
        return assocData;
    }, [getCachedBranchId]);

    const init = useCallback(async () => {
        try {
            const user = await CognitoData();
            const type = user.idToken.payload['custom:user_type'];
            const email = user.idToken.payload['email'];
            setUserType(type);
            setUserEmail(email);

            const branch_id = await getCachedBranchId();
            if (edit && id) {
                await loadExistingNotice(id, branch_id);
                return;
            }

            setLoadingNoticeTypes(true);
            const noticeTypeOptions = await fetchNoticeTypeOptions(branch_id);
            setNoticeTypes(noticeTypeOptions);
            if (noticeTypeOptions.length > 0) {
                const prefillNoticeType = searchParams.get('notice_type') || '';
                setNoticeType(
                    resolveNoticeTypeValue(prefillNoticeType, noticeTypeOptions)
                    || noticeTypeOptions[0].value
                );
            }

            if (!edit) {
                let allAcademicYears = getAllowedAcademicYears(forwardedContext?.academicYears || []);
                if (!allAcademicYears.length) {
                    const academicYearsRes = await dataService.GetAPI(`academic-years?filter=true&branch_id=${branch_id}&status=ongoing,upcoming`);
                    allAcademicYears = getAllowedAcademicYears(academicYearsRes.data?.data?.data || []);
                }

                let branchClasses = getActiveClasses(forwardedContext?.allClasses || []);
                if (!branchClasses.length) {
                    const classesRes = await dataService.GetAPI(`classes?branch_id=${branch_id}&sort=${encodeURIComponent('status+asc')}`);
                    branchClasses = getActiveClasses(classesRes.data?.data?.data || []);
                }
                setAllClasses(branchClasses);

                let assignedAssociations = forwardedContext?.staffAssociations || [];
                if (!isAdminCommunicationRole(type) && assignedAssociations.length === 0) {
                    const context = await getStaffAssociationContext(branch_id, email);
                    assignedAssociations = await getStaffAssociationsForAcademicYears(
                        branch_id,
                        allAcademicYears,
                        context.userData || {},
                    );
                    setStaffAssociations(assignedAssociations);
                }

                setAcademicYears(
                    isAdminCommunicationRole(type)
                        ? allAcademicYears
                        : filterAcademicYearsByAssociations(allAcademicYears, assignedAssociations)
                );
            }
        } catch {
            setToastErrorMessage('Something went wrong while loading');
        } finally {
            setLoadingNoticeTypes(false);
            setPageLoading(false);
        }
    }, [edit, forwardedContext, getCachedBranchId, id, searchParams]);

    useEffect(() => { init(); }, []);

    const fetchSections = useCallback(async (branch_id, class_id) => {
        setLoadingSections(true);
        try {
            if (isAdminRole) {
                const assocData = await getCachedAssociationsForAcademicYear(selectedAY._id);
                setSections(await getActiveSectionsByAssociations(branch_id, assocData, selectedAY._id, class_id));
            } else {
                setSections(await getActiveSectionsByAssociations(branch_id, staffAssociations, selectedAY._id, class_id));
            }
        } catch {
            setSections([]);
        } finally {
            setLoadingSections(false);
        }
    }, [getCachedAssociationsForAcademicYear, isAdminRole, selectedAY._id, staffAssociations]);

    const loadExistingNotice = async (noticeId, branch_id) => {
        const res = await dataService.GetAPI(`notice-board/updates/${noticeId}?branch_id=${branch_id}`);
        const notice = res.data?.data?.data || res.data?.data;
        if (!notice) return;
        setIsBatchedNotice(Boolean(notice.is_batched));
        const sectionDisplay = notice.sections?.length > 0
            ? notice.sections.map((section) => section.section_name).join(', ')
            : notice.section_name;
        setEditContext({
            ay_name: notice.academic_year_name,
            class_name: notice.class_name,
            section_name: sectionDisplay,
            type_name: notice.notice_type_label || getNoticeTypeLabel(notice.notice_type, [], ''),
            date: notice.date,
        });
        setNoticeType(notice.notice_type || '');
        setReceiverType(notice.receiver_type || 'class');
        setTitle(notice.title || '');
        setDescription(notice.description || '');
        setAttachments(notice.attachments || []);
        if (notice.receiver_type === 'student') {
            setSelectedStudent({ _id: notice.student_id, full_name: notice.student_name, student_id: notice.student_number });
            setStudentSearch(`${notice.student_name} (${notice.student_number})`);
        }
    };

    useEffect(() => {
        if (!selectedAY._id) {
            setClasses([]);
            setLoadingClasses(false);
            return;
        }
        setClasses(getClassesForAcademicYear(selectedAY._id));
        setLoadingClasses(false);
    }, [edit, forwardedContext, getClassesForAcademicYear, selectedAY._id]);

    useEffect(() => {
        if (edit) return;
        if (selectedAY._id && academicYears.length > 0 && !academicYears.some((item) => item._id === selectedAY._id)) {
            setSelectedAY({});
        }
    }, [academicYears, edit, selectedAY._id]);

    useEffect(() => {
        if (edit) return;
        if (selectedClass._id && classes.length > 0 && !classes.some((item) => item._id === selectedClass._id)) {
            setSelectedClass({});
            setSelectedSection({});
        }
    }, [classes, edit, selectedClass._id]);

    useEffect(() => {
        if (selectedClass._id && !edit) {
            getCachedBranchId().then(b => fetchSections(b, selectedClass._id));
        }
    }, [edit, fetchSections, forwardedContext, getCachedBranchId, selectedAY._id, selectedClass._id]);

    useEffect(() => {
        if (edit || selectedSection._id === ALL_SECTIONS_OPTION._id) return;
        if (selectedSection._id && sections.length > 0 && !sections.some((item) => item._id === selectedSection._id)) {
            setSelectedSection({});
        }
    }, [edit, sections, selectedSection._id]);

    useEffect(() => {
        if (edit || !selectedClass._id) return;
        if (sections.length > 0 && !selectedSection._id) {
            setSelectedSection(ALL_SECTIONS_OPTION);
            return;
        }
        if (sections.length === 0 && selectedSection._id === ALL_SECTIONS_OPTION._id) {
            setSelectedSection({});
        }
    }, [edit, sections, selectedClass._id, selectedSection._id]);

    useEffect(() => {
        if (edit || prefillApplied || pageLoading) return;

        const prefillAcademicYearId = searchParams.get('academic_year_id') || '';
        const prefillClassId = searchParams.get('class_id') || '';
        const prefillSectionId = searchParams.get('section_id') || '';
        const prefillNoticeType = searchParams.get('notice_type') || '';

        if (prefillNoticeType && noticeTypes.length > 0 && !noticeType) {
            setNoticeType(getNoticeTypeValue(prefillNoticeType));
        }

        if (!prefillAcademicYearId) {
            setPrefillApplied(true);
            return;
        }

        if (!selectedAY._id) {
            const matchedAY = academicYears.find((item) => item._id === prefillAcademicYearId);
            if (matchedAY) {
                handleSelectAY(matchedAY);
                return;
            }
            setPrefillApplied(true);
            return;
        }

        if (!prefillClassId) {
            setPrefillApplied(true);
            return;
        }

        if (!selectedClass._id) {
            const matchedClass = classes.find((item) => item._id === prefillClassId);
            if (matchedClass) {
                handleSelectClass(matchedClass);
                return;
            }
            if (!loadingClasses) {
                setPrefillApplied(true);
            }
            return;
        }

        if (!prefillSectionId) {
            setPrefillApplied(true);
            return;
        }

        if (!selectedSection._id) {
            const matchedSection = sections.find((item) => item._id === prefillSectionId);
            if (matchedSection) {
                handleSelectSection(matchedSection);
            }
            if (!loadingSections || matchedSection) {
                setPrefillApplied(true);
            }
            return;
        }

        setPrefillApplied(true);
    }, [
        academicYears,
        classes,
        edit,
        loadingClasses,
        loadingSections,
        noticeType,
        noticeTypes,
        pageLoading,
        prefillApplied,
        searchParams,
        sections,
        selectedAY._id,
        selectedClass._id,
        selectedSection._id,
        getNoticeTypeValue,
    ]);

    const handleSelectAY = async (ay) => {
        setSelectedAY(ay);
        setSelectedClass({});
        setSelectedSection({});
        setSections([]);
        if (isAdminRole) {
            await getCachedAssociationsForAcademicYear(ay._id);
        }
        setClasses(getClassesForAcademicYear(ay._id));
        setLoadingClasses(false);
        setLoadingSections(false);
    };

    const handleSelectClass = (cls) => {
        setSelectedClass(cls);
        setSelectedSection({});
        setSections([]);
        setLoadingSections(true);
    };

    const handleSelectSection = (sec) => {
        setSelectedSection(sec);
    };

    const handleReceiverTypeChange = (value) => {
        if (isReadOnly) return;
        setReceiverType(value);
        setSelectedStudent({});
        setStudentSearch('');
        setStudentDropdown([]);
        setStudentSearchStarted(false);
    };

    const handleStudentSearch = async (value) => {
        setStudentSearch(value);
        if (value.length < 2) {
            setStudentDropdown([]);
            setStudentSearchStarted(false);
            setLoadingStudents(false);
            return;
        }
        setStudentSearchStarted(true);
        setLoadingStudents(true);
        setStudentDropdown([]);
        try {
            const branch_id = await GetBranchId();
            const params = new URLSearchParams({
                branch_id,
                search: value,
                ...(selectedAY._id && { academic_year_id: selectedAY._id }),
                ...(selectedClass._id && { class_id: selectedClass._id }),
                ...(selectedSection._id && selectedSection._id !== ALL_SECTIONS_OPTION._id && { section_id: selectedSection._id }),
                status: 'active',
                filter: 'true',
            });
            const res = await dataService.GetAPI(`students?${params.toString()}`);
            const studentResults = res.data?.data?.students || res.data?.data?.data?.students || res.data?.data?.data || [];
            setStudentDropdown(studentResults);
        } catch {
            setStudentDropdown([]);
        } finally {
            setLoadingStudents(false);
        }
    };

    const handleFileUpload = async (file) => {
        if (!file) return;
        if (attachments.length >= 3) { setToastErrorMessage('Maximum 3 attachments allowed'); return; }
        if (!ALLOWED_ATTACHMENT_TYPES.includes(file.type)) { setToastErrorMessage('Only JPG, JPEG, PNG, and PDF files are allowed'); return; }
        if (file.size > 5 * 1024 * 1024) { setToastErrorMessage('File size must not exceed 5MB'); return; }
        setUploading(true);
        try {
            const branch_id = await GetBranchId();
            const path = `notice-board/updates/${branch_id}/${selectedAY._id || 'ay'}/${moment().format('YYYY-MM-DD')}/${file.name}`;
            const key = await S3UploadHook(file, path, () => {}, true);
            setAttachments(prev => [...prev, { key, name: file.name }]);
        } catch {
            setToastErrorMessage('File upload failed. Please try again.');
        } finally {
            setUploading(false);
        }
    };

    const removeAttachment = (index) => {
        setAttachments(prev => prev.filter((_, i) => i !== index));
    };

    const handleAttachmentDownload = async (attachment) => {
        if (!attachment?.key) return;
        try {
            await downloadS3Object(attachment.key);
        } catch {
            setToastErrorMessage('Unable to download attachment');
        }
    };

    const handleCreateNoticeType = async () => {
        const trimmedLabel = newNoticeTypeLabel.trim();
        if (!trimmedLabel) {
            setToastErrorMessage('Please enter a update type');
            return;
        }
        try {
            setToastErrorMessage('');
            setLoadingNoticeTypes(true);
            const branch_id = await GetBranchId();
            const response = await dataService.PostAPI({
                branch_id,
                type_label: trimmedLabel,
            }, 'notice-board/notice-types');
            const responsePayload = response?.data?.data || response?.data || {};
            const createdType = responsePayload?.data || responsePayload;
            if (!createdType?._id) {
                setToastErrorMessage(responsePayload?.message || 'Failed to create update type');
                return;
            }

            const nextType = {
                _id: createdType._id,
                value: createdType.type_key,
                label: createdType.type_label,
                typeKey: createdType.type_key,
                isDefault: createdType.is_default,
            };
            setNoticeTypes((prev) => {
                const withoutDuplicate = prev.filter((item) => item.value !== nextType.value);
                return [...withoutDuplicate, nextType].sort((a, b) => a.label.localeCompare(b.label));
            });
            setNoticeType(nextType.value);
            setNewNoticeTypeLabel('');
            setShowAddNoticeType(false);
            setToastmessage(responsePayload?.message || 'Update type created successfully');
        } catch (err) {
            setToastErrorMessage(err?.response?.data?.message || 'Failed to create update type');
        } finally {
            setLoadingNoticeTypes(false);
        }
    };

    const validate = () => {
        if (uploading) { setToastErrorMessage('Please wait for file uploads to finish'); return false; }
        if (!edit) {
            if (!selectedAY._id) { setToastErrorMessage('Please select Academic Year'); return false; }
            if (!selectedClass._id) { setToastErrorMessage('Please select Class'); return false; }
            if (!selectedSection._id) { setToastErrorMessage('Please select Section'); return false; }
        }
        if (!noticeType) { setToastErrorMessage('Please select a type'); return false; }
        if (!title.trim()) { setToastErrorMessage('Please enter a title'); return false; }
        if (!description.trim()) { setToastErrorMessage('Please enter a description'); return false; }
        if (receiverType === 'student' && !selectedStudent._id) { setToastErrorMessage('Please select a student'); return false; }
        return true;
    };

    const handleSave = async () => {
        setSubmitSelected(true);
        if (!validate()) return;
        setLoading(true);
        try {
            const branch_id = await GetBranchId();
            const body = {
                notice_type: noticeType,
                receiver_type: receiverType,
                title: title.trim(),
                description: description.trim(),
                attachments,
                student_id: receiverType === 'student' ? selectedStudent._id : null,
                student_name: receiverType === 'student' ? selectedStudent.full_name : null,
                student_number: receiverType === 'student' ? selectedStudent.student_id : null,
            };

            let response;
            if (edit && id) {
                response = await dataService.PatchAPI({
                    ...body,
                    is_batched: isBatchedNotice,
                }, `notice-board/updates/${id}`);
            } else {
                const selectedSections = selectedSection._id === ALL_SECTIONS_OPTION._id
                    ? sections.map((section) => ({
                        section_id: section.section_id || section._id,
                        section_name: section.section_name || section.name,
                    }))
                    : [{
                        section_id: selectedSection.section_id || selectedSection._id,
                        section_name: selectedSection.section_name || selectedSection.name,
                    }];
                Object.assign(body, {
                    branch_id,
                    academic_year_id: selectedAY._id,
                    academic_year_name: selectedAY.name,
                    class_id: selectedClass._id,
                    class_name: selectedClass.name,
                    sections: selectedSections,
                });
                response = await dataService.PostAPI(body, 'notice-board/updates');
            }

            if (response?.data?.status === 200 || response?.data?.status === 201) {
                setToastmessage(response.data.message || 'Update added successfully');
                navigate('/noticeboard/classroom?type=updates');
            } else {
                setToastErrorMessage(response?.data?.message || 'Something went wrong');
            }
        } catch (err) {
            setToastErrorMessage(err?.response?.data?.message || 'Something went wrong');
        } finally {
            setLoading(false);
        }
    };

    const isReadOnly = isViewMode || (edit && editContext.date < moment().format('YYYY-MM-DD'));
    const academicYearValue = selectedAY?.name || 'Select Academic Year';
    const classValue = selectedClass?.name || 'Select Class';
    const sectionValue = selectedSection?.name || (sections.length > 0 ? ALL_SECTIONS_OPTION.name : 'Select Section');
    const noticeTypeValue = getNoticeTypeLabel(noticeType, noticeTypes, 'Select Type');
    const noticeTypeOptions = noticeTypes.map((item) => ({ ...item, name: item.label }));
    const sectionOptions = receiverType === 'class' && sections.length > 0
        ? [ALL_SECTIONS_OPTION, ...sections]
        : sections;

    return (
        <>
            <CardHeader noPadding>
                {isReadOnly ? (
                    <TopBarWithShadow
                        Tittle="View Notice"
                        isback={true}
                        backLocation="/noticeboard/classroom?type=updates"
                    />
                ) : (
                    <div className="mainDataCntnrTop shadow-s13" style={{ position: 'sticky', top: 0, zIndex: 10 }}>
                        <h5 className="pageHeader addclass">{edit ? 'Edit Update' : 'Add Update'}</h5>
                        <div className="flex items-center">
                            <UpdateButton
                                ButtonName="Cancel"
                                loading={false}
                                handleOnCLick={() => navigate('/noticeboard/classroom?type=updates')}
                                classKey="cancl-btn"
                            />
                            <UpdateButton
                                ButtonName={edit ? 'Update' : 'Add'}
                                loading={loading}
                                handleOnCLick={handleSave}
                                classKey="actn-btn onboardInstitution"
                            />
                        </div>
                    </div>
                )}
                {toastErrorMessage !== '' && (
                    <Toast message={toastErrorMessage} type="error" setToastmessage={setToastErrorMessage} />
                )}

                {pageLoading && (
                    <CustomOverLay Active text="Loading..." classKey="flex flex-col justify-center items-center sidebarOpenedOverlay" />
                )}

                {!pageLoading && (<div className="mainDataCntnrPageDiv scrollBlue_thick">
                    <div className="2xl:w-[60%] w-[80%] mx-auto">

                        {/* Context — read-only labels (edit) or dropdowns (add) */}
                        <div className="border border-[#D0D5DD] p-3 rounded mb-4">
                            {edit ? (
                                <div className="flex flex-wrap ">
                                    {[
                                        { label: 'Academic Year', value: editContext.ay_name , width: 'w-[25%]', style:'' },
                                        { label: 'Class', value: editContext.class_name, width: 'w-[17%]', style:'' },
                                        { label: 'Section', value: editContext.section_name, width: 'w-[17%]', style:'pr-2' },
                                        { label: 'Type', value: editContext.type_name, width: 'w-[23%]', style:'pr-2' },
                                        { label: 'Date', value: editContext.date ? moment(editContext.date).format('MMM DD, YYYY') : '', width: 'w-[17%]', style:'' },
                                    ].map(({ label, value, width, style }) => (
                                        <div key={label} className={`flex items-center ${width} ${style}`}>
                                            <p className="pr-2">{label}</p>
                                            <p className="font-semibold more-lines" title={value || '-'}>
                                                {value || '-'}
                                            </p>
                                        </div>
                                    ))}
                                </div>
                                
                            ) : (
                                <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-5 gap-4 items-start">
                                    <div className="flex flex-col">
                                        <p className="mb-1">Academic Year <span className="text-[#F04438]">*</span></p>
                                        <FeeStructureDropdown
                                            dropDownName="academic_year"
                                            id="academic_year"
                                            test_id="academic_year"
                                            value={academicYearValue}
                                            placeHolder="Select Academic Year"
                                            options={academicYears}
                                            handleOnchangeInput={(key, value) => handleSelectAY(value)}
                                            showErrorBorder={submitSelected && !selectedAY._id}
                                        />
                                    </div>

                                    <div className="flex flex-col">
                                        <p className="mb-1">Class <span className="text-[#F04438]">*</span></p>
                                        <FeeStructureDropdown
                                            dropDownName="class_name"
                                            value={classValue}
                                            placeHolder="Select Class"
                                            options={classes}
                                            handleOnchangeInput={(key, value) => handleSelectClass(value)}
                                            loading={loadingClasses}
                                            buttonDisabled={!selectedAY._id || loadingClasses}
                                            applyBGForDisabled={true}
                                            showErrorBorder={submitSelected && !selectedClass._id}
                                        />
                                    </div>

                                    <div className="flex flex-col">
                                        <p className="mb-1">Section <span className="text-[#F04438]">*</span></p>
                                        <FeeStructureDropdown
                                            dropDownName="section"
                                            value={sectionValue}
                                            placeHolder="Select Section"
                                            options={sectionOptions}
                                            handleOnchangeInput={(key, value) => handleSelectSection(value)}
                                            loading={loadingSections}
                                            buttonDisabled={!selectedClass._id || loadingSections}
                                            applyBGForDisabled={true}
                                            showErrorBorder={submitSelected && !selectedSection._id}
                                        />
                                    </div>

                                    {/* Type */}
                                    <div className="flex flex-col mr-2 relative" ref={typeRef}>
                                        <p className="mb-1">Type <span className="text-[#F04438]">*</span></p>
                                        <button
                                            type="button"
                                            className={`sec_filter_btn relative ml-0 w-full ${submitSelected && !noticeType ? 'redBorder' : ''}`}
                                            style={{'padding':'0.275rem 0.5rem'}}
                                            onClick={() => {
                                                setOpenDropdown((d) => d === 'type' ? '' : 'type');
                                                setShowAddNoticeType(false);
                                                setNewNoticeTypeLabel('');
                                            }}
                                        >
                                            <p className=" text-[#000000] more-lines pr-2">
                                                {getNoticeTypeLabel(noticeType, noticeTypes, 'Select Type')}
                                            </p>
                                            <img loading="lazy" src="/images/dropdown-icon.png" alt="icon"
                                                className={`absolute top-[50%] -translate-y-[50%] dropdown-close right-4 ${openDropdown === 'type' ? 'transform rotate-180' : ''}`} />
                                        </button>
                                        {openDropdown === 'type' && (
                                            <ul className="ant-picker-dropdown slct_drp_dwn class-diary-dropdown w-full min-w-0 left-0 right-auto" style={{'left':'6px', top:'63px'}}>
                                                <li className="max-h-[220px] overflow-auto scroll-bar">
                                                    <ul className="border-b border-[#E6E8EA]">
                                                        {showAddNoticeType ? (
                                                            <li className="px-2 py-1">
                                                                <div className="flex items-center gap-2">
                                                                    <input
                                                                        type="text"
                                                                        className="w-full bg-transparent !border-0 !border-t-0 !border-l-0 !border-r-0 !border-b !border-[#106EB4] rounded-none outline-none focus:outline-none focus:ring-0 focus:shadow-none px-0 pb-1  text-[#031624]"
                                                                        placeholder="New Type"
                                                                        value={newNoticeTypeLabel}
                                                                        maxLength={100}
                                                                        autoFocus
                                                                        onChange={(e) => setNewNoticeTypeLabel(e.target.value)}
                                                                        onKeyDown={(e) => {
                                                                            if (e.key === 'Enter') {
                                                                                e.preventDefault();
                                                                                handleCreateNoticeType();
                                                                            }
                                                                        }}
                                                                    />
                                                                    <button
                                                                        type="button"
                                                                        className="shrink-0"
                                                                        onClick={handleCreateNoticeType}
                                                                    >
                                                                        <img src="/images/otp-tick.svg" alt="save type" class="w-4 h-4 prevent-click" />
                                                                    </button>
                                                                    <button
                                                                        type="button"
                                                                        className="shrink-0"
                                                                        onClick={() => {
                                                                            setShowAddNoticeType(false);
                                                                            setNewNoticeTypeLabel('');
                                                                        }}
                                                                    >
                                                                        <img src="/images/file-remove.svg" alt="cancel type" className="w-4 h-4 prevent-click" />
                                                                    </button>
                                                                </div>
                                                            </li>
                                                        ) : (
                                                            <li onClick={() => setShowAddNoticeType(true)}>
                                                                <a className="slct_drp_dwn_optn selected_Class !flex !flex-row items-center gap-2 whitespace-nowrap" href="javascript:void(0)" style={{ padding: '6.5px 12px ' }}>
                                                                    <img src="/images/add-icon-blue.svg" alt="add type" className="w-4 h-4" />
                                                                    <span class='text-[#106EB4]'>New Type</span>
                                                                </a>
                                                            </li>
                                                        )}
                                                    </ul>
                                                    {loadingNoticeTypes ? (
                                                        <div className="pl-2 pt-2"><SearchShimmer count={3} height={'110px'} /></div>
                                                    ) : noticeTypes.length > 0 ? noticeTypes.map((item) => (
                                                        <ul key={item.value}>
                                                            <li onClick={() => {
                                                                setNoticeType(item.value);
                                                                setShowAddNoticeType(false);
                                                                setOpenDropdown('');
                                                            }}>
                                                                <a className="slct_drp_dwn_optn selected_Class" href="javascript:void(0)">{item.label}</a>
                                                            </li>
                                                        </ul>
                                                    )) : (
                                                        <li><a className="slct_drp_dwn_optn">- No types available -</a></li>
                                                    )}
                                                </li>
                                            </ul>
                                        )}
                                    </div>
                                    <div className="flex flex-col">
                                        <p className="mb-1">Date <span className="text-[#F04438]">*</span></p>
                                        <p className="mb-1 font-medium">{moment().format('MMM DD, YYYY')}</p>
                                    </div>
                                </div>
                            )}
                        </div>

                        {/* Notice form — follows Issue Invoice pattern */}
                        <div className="border border-[#D0D5DD] p-3 rounded">
                            {/* Receiver — editable only while adding */}
                            {!edit && (
                                <div className="flex items-start mb-4">
                                    <p className=" min-w-[130px]">Receiver</p>
                                    <div className="flex items-center gap-4">
                                        <div className="relative custom-radioBlue flex items-center">
                                            <input
                                                type="radio"
                                                id="receiver_class"
                                                name="receiver_type"
                                                checked={receiverType === 'class'}
                                                onChange={() => handleReceiverTypeChange('class')}
                                                disabled={isReadOnly}
                                            />
                                            <label htmlFor="receiver_class" className=" cursor-pointer ml-1">Class / Section</label>
                                        </div>
                                        <div className="relative custom-radioBlue flex items-center ml-4">
                                            <input
                                                type="radio"
                                                id="receiver_student"
                                                name="receiver_type"
                                                checked={receiverType === 'student'}
                                                onChange={() => handleReceiverTypeChange('student')}
                                                disabled={isReadOnly}
                                            />
                                            <label htmlFor="receiver_student" className=" cursor-pointer ml-1">Specific Student</label>
                                        </div>
                                    </div>
                                </div>
                            )}

                            {/* Student search — shown only when Specific Student selected */}
                            {receiverType === 'student' && (
                                <div className="flex items-start mb-4" ref={studentRef}>
                                    <p className=" min-w-[130px]">Student <span className="text-[#F04438]">*</span></p>
                                    {edit || isReadOnly ? (
                                        <p className="font-semibold ">{selectedStudent.full_name || '-'} [{selectedStudent.student_id || '-'}]</p>
                                    ) : (
                                        <div className="relative w-[280px]">
                                            <input
                                                type="text"
                                                className={`border ${submitSelected && !selectedStudent._id ? 'redBorder' : 'border-[#D0D5DD]'} w-full slct-inpt-fld`}
                                                style={{ paddingRight: '35px' }}
                                                placeholder="Search by Student Name / ID"
                                                value={studentSearch}
                                                autoComplete="off"
                                                onChange={(e) => {
                                                    setStudentSearch(e.target.value);
                                                    setSelectedStudent({});
                                                    handleStudentSearch(e.target.value);
                                                }}
                                            />
                                            <button className="absolute top-[50%] -translate-y-[50%] right-2">
                                                <img loading="lazy" src="/images/search.svg" alt="search" />
                                            </button>
                                            {studentSearchStarted && (
                                                <ul className="slct_drp_dwn min-w-full select_student">
                                                    <li className="max-h-[150px] overflow-auto scroll-bar">
                                                        {loadingStudents ? (
                                                            <div className="pl-2 pt-2"><SearchShimmer count={2} height={'70px'} /></div>
                                                        ) : studentDropdown.length === 0 ? (
                                                            <ul>
                                                                <li>
                                                                    <span className="selected_Class block cursor-default">
                                                                        - No student found for the given criteria -
                                                                    </span>
                                                                </li>
                                                            </ul>
                                                        ) : studentDropdown.map(student => (
                                                            <ul key={student._id}>
                                                                <li onClick={() => {
                                                                    setSelectedStudent(student);
                                                                    setStudentSearch(`${student.full_name} (${student.student_id})`);
                                                                    setStudentSearchStarted(false);
                                                                    setLoadingStudents(false);
                                                                    setStudentDropdown([]);
                                                                }}>
                                                                    <a className="selected_Class" href="javascript:void(0)" title={`${student.full_name} (${student.student_id})`}>
                                                                        {student.full_name} ({student.student_id})
                                                                    </a>
                                                                </li>
                                                            </ul>
                                                        ))}
                                                    </li>
                                                </ul>
                                            )}
                                        </div>
                                    )}
                                </div>
                            )}

                            {/* Title */}
                            <div className="flex items-start mb-3">
                                <p className="min-w-[130px]">Title <span className="text-[#F04438]">*</span></p>
                                {isReadOnly ? (
                                    <p className="w-full">{title || '-'}</p>
                                ) : (
                                    <div className="w-full">
                                        <input
                                            type="text"
                                            className={`inpt-fld w-full ${submitSelected && !title.trim() ? 'redBorder' : ''}`}
                                            maxLength={100}
                                            value={title}
                                            onChange={(e) => setTitle(e.target.value)}
                                            placeholder="Enter update title"
                                        />
                                        <p className="text-xs text-[#818E98] text-right">{title.length}/100</p>
                                    </div>
                                )}
                            </div>

                            {/* Description */}
                            <div className="flex items-start mb-3">
                                <p className=" min-w-[130px]">Description <span className="text-[#F04438]">*</span></p>
                                {isReadOnly ? (
                                    <p className=" w-full">{description || '-'}</p>
                                ) : (
                                    <div className="w-full">
                                        <textarea
                                            className={`txt-fld w-full ${submitSelected && !description.trim() ? 'redBorder' : ''}`}
                                            maxLength={500}
                                            value={description}
                                            id='update_description'
                                            onChange={(e) => setDescription(e.target.value)}
                                            placeholder="Enter update description"
                                            style={{ height: '100px' }}
                                        />
                                        <p className="text-xs text-[#818E98] text-right">{description.length}/500</p>
                                    </div>
                                )}
                            </div>

                            {/* File Attachments */}
                            <div className="flex items-start">
                                <p className="min-w-[130px]">Attachments</p>
                                <div className="w-full">
                                    {/* Uploaded files */}
                                    {attachments.map((att, i) => (
                                        <div key={i} className="flex items-center gap-2 mb-2">
                                            {isReadOnly ? (
                                                <button
                                                    type="button"
                                                    className="text-[#106EB4] underline text-left"
                                                    onClick={() => handleAttachmentDownload(att)}
                                                >
                                                    {att.name}
                                                </button>
                                            ) : (
                                                <p>{att.name}</p>
                                            )}
                                            {!isReadOnly && (
                                                <button type="button" onClick={() => removeAttachment(i)}>
                                                    <img src="/images/file-remove.svg" alt="remove" className="w-4 h-4" />
                                                </button>
                                            )}
                                        </div>
                                    ))}
                                    {/* Upload button */}
                                    {!isReadOnly && attachments.length < 3 && (
                                        <div>
                                            {uploading ? (
                                                <p className="text-xs text-[#818E98]">Uploading...</p>
                                            ) : (
                                                <label className="cursor-pointer inline-flex items-center gap-2  underline">
                                                    <img src="/images/add-icon-blue.svg" alt="add" className="w-4 h-4" />
                                                    Add Attachment ({attachments.length}/3)
                                                    <input type="file" className="hidden" accept=".jpg,.jpeg,.png,.pdf,image/jpeg,image/jpg,image/png,application/pdf"
                                                        onChange={(e) => handleFileUpload(e.target.files[0])} />
                                                </label>
                                            )}
                                            <p className="text-xs text-[#818E98] mt-1">JPG, JPEG, PNG, or PDF; max 5MB each</p>
                                        </div>
                                    )}
                                    {attachments.length === 0 && isReadOnly && (
                                        <p className=" text-[#031624]">-</p>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                )}
            </CardHeader>
        </>
    );
}
